<template>
  <el-table-column
    prop="group_tax_number"
    sortable="custom"
    label="Csoportos adószám"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      {{ scope.row.company.group_tax_number }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'group_tax_number',
};
</script>
